export default function AccessSection() {
  return (
    <section id="access" className="bg-background-50 py-24 md:py-32 px-6">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start mb-16">
          <div className="lg:col-span-5">
            <p className="text-[10px] tracking-[0.5em] uppercase text-primary-600 mb-4">— Access —</p>
            <h2 className="font-heading text-5xl md:text-7xl text-foreground-950 leading-tight">
              展示場所
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-8">
            <p className="text-sm text-foreground-700 leading-loose">
              現在の展示場所の案内しております。現在株式会社ズーム様に展示させていただいております。<br/>
              展示場所は変わりますので、都度お気軽にお問い合わせ頂ければと思います。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <div className="aspect-[16/10] overflow-hidden rounded-sm border border-background-200">
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22212.579413114447!2d139.35410630881358!3d35.44766890343078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601900061897bef7%3A0x509fef5e8d0c14b5!2z5qCq5byP5Lya56S-IOOCuuODvOODoA!5e0!3m2!1sja!2sjp!4v1783053886902!5m2!1sja!2sjp" width="800" height="600" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="strict-origin-when-cross-origin"></iframe>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="p-6 bg-background-100 rounded-sm border-l-2 border-primary-500">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 dark:text-foreground-950 rounded-sm">
                  <i className="ri-train-line text-lg"></i>
                </div>
                <div>
                  <p className="font-heading text-lg text-foreground-950">電車でお越しの方</p>
                  <p className="text-xs text-foreground-600 mt-2 leading-loose">
                    小田急線 本厚木駅より徒歩３０分<br />
                    （路線バスのご利用をお勧めいたします）<br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}